import CRUDRequirementList from "../../features/CRUD/crudRequirementList/CRUDRequirementList";

const CRUDRequirement = () => {
  return (
    <div>
      <CRUDRequirementList />
    </div>
  );
};

export default CRUDRequirement;
